"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionContainer = void 0;
const react_1 = __importStar(require("react"));
const DSTL001_Detail_Child_1 = require("./component/DSTL001_Detail_Child");
const styled_components_1 = __importStar(require("styled-components"));
const server_1 = require("../../../server");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const SubmissionContainerStyled = styled_components_1.default.div `
	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100%;
`;
const desktopStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: row;
	gap: 20px;
`;
exports.SubmissionContainer = react_1.default.memo(({ test_id }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [statisticItem, setStatisticItem] = react_1.default.useState({
        average: {
            '100%': {
                score: 0,
                corrects: 0,
            },
            '50%': {
                score: 0,
                corrects: 0,
            },
            '10%': {
                score: 0,
                corrects: 0,
            },
        },
        submitted: 0,
        not_submitted: 0,
        question_count: 0,
        test_id: '',
        subject_item: '',
        hardest_rank: [],
    });
    const { data: statisticData, refetch: statisticRefetch } = (0, server_1.useStatistics)({
        test_id,
    });
    (0, react_1.useEffect)(() => {
        statisticRefetch();
    }, [test_id]);
    (0, react_1.useEffect)(() => {
        if (!statisticData)
            return;
        setStatisticItem(statisticData);
    }, [statisticData]);
    return (react_1.default.createElement(SubmissionContainerStyled, { "$isMobile": isMobile, className: "_001" },
        react_1.default.createElement(DSTL001_Detail_Child_1.SubmissionStatusGraph, { isHome: true, test_id: test_id }),
        react_1.default.createElement(DSTL001_Detail_Child_1.AverageExamAttendance, { isHome: true, question_count: statisticItem.question_count, average: statisticItem.average['100%'] })));
});
